type WebViewDebugPlugin = {
  setEnabled(options: { enabled: boolean }): Promise<void>;
};

let lastSyncedDeveloperFlag: boolean | null = null;

/**
 * Sync developer-claim WebView debug toggle to the native Android layer.
 *
 * No-op on web/iOS and in environments where the plugin is unavailable.
 */
export const syncAndroidWebViewDebug = async (enabled: boolean): Promise<void> => {
  if (lastSyncedDeveloperFlag === enabled) {
    return;
  }

  if (typeof window === "undefined") {
    lastSyncedDeveloperFlag = enabled;
    return;
  }

  try {
    const { Capacitor, registerPlugin } = await import("@capacitor/core");
    if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "android") {
      lastSyncedDeveloperFlag = enabled;
      return;
    }

    const WebViewDebug = registerPlugin<WebViewDebugPlugin>("WebViewDebug");
    await WebViewDebug.setEnabled({ enabled });
    lastSyncedDeveloperFlag = enabled;
  } catch {
    // Native plugin is optional for non-Android environments and older builds.
    lastSyncedDeveloperFlag = enabled;
  }
};
